<template>
    <div class="toolbar navigation-bar">
        <div class="wbtn-array" style="grid-column: 2;">
            <slot name="main-group">

            </slot>
        </div>
        <div class="wbtn-array right-aligned" style="grid-column: 3;">
            <slot name="right-group">

            </slot>
        </div>
    </div>
</template>

<script lang="ts">
    require('@/assets/portal.css');
    import { Component, Prop, Vue } from 'vue-facing-decorator';

    @Component
    export default class NavigationTabToolbar extends Vue {

    }
</script>

<style scoped>
    .navigation-bar {
        display: grid;
        grid-template-columns: 1fr 1fr 1fr;
        justify-items: center;
        background-color: var(--background-toolbar);
    }
</style>
